import React from 'react';
import { useNavigate } from 'react-router-dom';
// constants
import Routes from '@/constants/Routes';
import { MUSTARD_BROWN, PERSIMMON } from '@/constants/colors';
import { MAX_BURNOUT_ITEMS } from '@/pages/instamart/campaign/create/widgets/Nudge/constants';
// styles
import styles from './NearExhaustionCampaignsList.module.scss';
// helpers
import { format, formatNumberIntl, prefixWithRupee } from '@/helpers/utils';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { tokens } from '@swiggy-private/dls-web-common/dist/components/tokens';
//stores
import useSearchCampaignStore from '@/stores/SearchCampaign';
const NearExhaustionCampaignItem = ({ item, }) => {
    const navigate = useNavigate();
    const handleNearExhaustionCampaignItemClick = () => {
        navigate(format(Routes.INSTAMART.CAMPAIGN_DETAILS, item.id), {
            preventScrollReset: true,
        });
    };
    return (React.createElement("div", { className: styles.burnOutItem, onClick: handleNearExhaustionCampaignItemClick },
        React.createElement(Text, { variant: DlsFontVariants.body_B2_Bold, customColor: {
                dark: PERSIMMON,
                light: PERSIMMON,
            } }, item.name),
        React.createElement(Text, { variant: DlsFontVariants.body_B2_Med }, "has exhausted from"),
        React.createElement(Text, { variant: DlsFontVariants.body_B2_Bold, customColor: {
                dark: MUSTARD_BROWN,
                light: MUSTARD_BROWN,
            } }, prefixWithRupee(formatNumberIntl({ value: item.budget }))),
        React.createElement(Text, { variant: DlsFontVariants.body_B2_Med }, "to"),
        React.createElement(Text, { variant: DlsFontVariants.body_B2_Bold, customColor: {
                dark: MUSTARD_BROWN,
                light: MUSTARD_BROWN,
            } }, prefixWithRupee(formatNumberIntl({
            value: Math.max(Number((item.budget - item.budgetBurnt).toFixed(0)), 0),
        })))));
};
const NearExhaustionCampaignsList = ({ nearExhaustionCampaigns, }) => {
    const navigate = useNavigate();
    const { setSelectedOptions } = useSearchCampaignStore((state) => ({
        setSelectedOptions: state.campaignFilter.setSelectedCampaigns,
    }));
    const handleShowAllClick = () => {
        const ids = nearExhaustionCampaigns.map((item) => item.id);
        setSelectedOptions(ids);
        navigate(format(Routes.INSTAMART.CAMPAIGN_LIST), {
            preventScrollReset: true,
        });
    };
    const visibleItems = nearExhaustionCampaigns.slice(0, MAX_BURNOUT_ITEMS);
    return (React.createElement(React.Fragment, null,
        visibleItems.map((item) => (React.createElement(NearExhaustionCampaignItem, { key: item.id, item: item }))),
        nearExhaustionCampaigns.length > MAX_BURNOUT_ITEMS && (React.createElement("div", { className: styles.showMoreText },
            React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold }, `+${nearExhaustionCampaigns.length - MAX_BURNOUT_ITEMS} more campaigns budget exhausted`),
            React.createElement("div", { className: styles.warningItem },
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_High_Emphasis }),
                React.createElement("div", { className: styles.warningPill, onClick: handleShowAllClick },
                    React.createElement(Text, { variant: DlsFontVariants.body_B2_Med, customColor: {
                            dark: tokens.colors.chalk100,
                            light: tokens.colors.chalk100,
                        } }, "Show All")))))));
};
export default NearExhaustionCampaignsList;
